import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { IrisIconComponent, IconSizes } from '@sondermind/iris/icon';
import { SonderAvatarComponent } from '@sondermind/ai-chat-angular';

export type W9AgentTab = 'chat' | 'tasks';

@Component({
  selector: 'member-w9-agent-panel-header',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IrisIconComponent, SonderAvatarComponent],
  styleUrls: ['./w9-agent-panel-header.component.scss'],
  templateUrl: './w9-agent-panel-header.component.html',
})
export class W9AgentPanelHeaderComponent {
  @Input() activeTab: W9AgentTab = 'chat';
  @Output() tabChange = new EventEmitter<W9AgentTab>();

  readonly iconSizes = IconSizes;

  onTab(tab: W9AgentTab): void { this.tabChange.emit(tab) }
}
